export const ENDPOINT = process.env.REACT_APP_API_ENDPOINT

export const ENDPOINTLOMA = process.env.REACT_APP_API_LOMA_ENDPOINT

export const RESPONSE_MESSAGE = {
  SUCCESS: 'บันทึกข้อมูลสำเร็จ',
  FAIL: 'บันทึกข้อมูลไม่สำเร็จ'
}

export const HERO_TYPE = [
  'RECYCLE_SHOP',
  'SCOOTER',
  'DROP_POINT',
  'POSTAL',
  'CIRCULAR_BIN',
  'FACTORY'
]

export const STATUS = [
  'PENDING',
  'REGISTERED',
  'APPROVED',
  'SUSPENDED',
  'SUGGEST',
  'DELETED'
]

export const APPUSERS_STATUS = [
  'ENABLED',
  'DEACTIVATE',
]

export const LOMAUSERS_STATUS = [
  'ACTIVE',
  'INACTIVE',
]

export const CATEGORY = [
  'หมวดกระดาษ',
  'หมวดพลาสติก',
  'หมวดโลหะ',
  'หมวดแก้ว',
  'หมวด e-waste',
  'หมวดเหล็ก',
  'หมวดอื่นๆ'
]

export const UNIT = [
  'KG',
  'BOX',
  'PIECE',
  'LITER',
  'OTHER'
]

export const ROLE = [
  'ADMIN',
  'USER'
]

export const APPS = [
  'HERO',
  'GREEN2GET',
  'LOMA'
]

export const LANG = [
  'TH',
  'EN',
]

export const DATE = {
  FORMAT: 'YYYY-MM-DD'
}

export const ACTION = {
  CREATE: 'Create',
  UPDATE: 'Update'
}

export const POINTACTION = [
  'ค้นพบสินค้าใหม่',
  'เพิ่มวิธีคัดแยก',
  'ส่งต่อ',
  'แนะนำฮีโร่ใหม่'
]

export const ANNOUNCEMENT_STATUS = {
  ON_ANNOUNCE: 'กำลังประกาศหาผู้รับ',
  EXP_ANNOUNCE: 'เมื่อหมดอายุ(48 ชม.)',
  HERO_REQUEST_ANNOUNCE: 'ผู้รับยื่นข้อเสนอ',
  USER_ACCEPT_ANNOUNCE: 'ผู้ใช้รับข้อเสนอ',
  USER_CONFIRM_SENT: 'ผู้ใช้ยืนยันส่งต่อ',
  USER_REJECTED: 'ผู้ใช้ยกเลิกส่งต่อ',
  HERO_REJECTED: 'ผู้รับยกเลิกส่งต่อ',
  HERO_OFFERED: 'ส่งต่อสำเร็จ',
  DELETE: 'ลบ (กดยกเยิก การประกาศ)',
  EXPIRED: 'หมดอายุ',
  CANCELED_HERO: 'ถูกยกเลิกโดยฮีโร่',
  CANCELED_USER: 'ถูกยกเลิกโดยผู้ใช้'
}

export const TRANSACTION_STATUS = {
  USER_REJECTED: 'ผู้ใช้กดยกเลิก',
  USER_KEEP_BIN: 'สินค้าเก็บในถัง',
  USER_DELETE_BIN: 'สินค้าลบออกจากถัง',
  SUCCESS_PENDING: 'ส่งต่อให้ฮีโร่',
  SUCCESS_HEROCONFIRM: 'ฮีโร่ยืนยันการส่งต่อ'
}

export const HERO_TYPE_MESSAGE = {
  RECYCLE_SHOP: 'ร้านรับซื้อของเก่า',
  SCOOTER: 'รถรับซื้อของเก่า',
  DROP_POINT: 'จุดรับบริจาค',
  POSTAL: 'ส่งทางพัสดุ',
  FACTORY: 'โรงงานรีไซเคิล'
}

export const HERO_COIN_STATUS = {
  PAYMENT_PENDING: 'รอชำระเงิน',
  PAYMENT_SUCCESS: 'ชำระเงินสำเร็จ รอตรวจสอบหลักฐาน',
  ADDCOIN_SUCCESS: 'เติมเหรียญเรียบร้อย',
  PAYMENT_INVALID: 'หลักฐานไม่ถูกต้อง',
  PAYMENT_CANCEL: 'ผู้ใช้กดยกเลิก',
  TIMEOUT: 'หมดเวลา'
}


/** ชนิดของรางวัล — คนละเรื่องกับ REWARD_CATAGORY ซึ่งเป็นตัวกรอง UI */
export const REWARD_TYPE = {
  PRODUCT: { value: 'PRODUCT', label: 'สินค้า' },
  COUPON: { value: 'COUPON', label: 'คูปอง' }
}

/**
 * ป้ายของทุกช่องทาง ใช้ตอน "แสดงผล" — ต้องครบทุกค่าที่ backend เขียนลงข้อมูลได้
 * ต้องตรงกับ PointConstant.Channel ฝั่ง backend
 */
export const POINT_CHANNEL_LABEL = {
  APP: 'ในแอป',
  HERO_ACCEPT: 'ส่งต่อจากแอป ฮีโร่กดรับ',
  ANNOUNCEMENT: 'ส่งต่อผ่านประกาศ',
  LOMA: 'ส่งต่อผ่าน LOMA',
  CIRCULAR_BIN: 'Circular bin'
}

/**
 * ช่องทางที่ให้แอดมิน "เลือก" เป็นเงื่อนไขได้
 *
 * ช่องทางจะโผล่เฉพาะตอนเลือกประเภท "ส่งต่อ" เท่านั้น จึงมีแค่ช่องทางของการส่งต่อ
 * ไม่รวม APP (เลือกไปก็ไม่มีวันตรงกับพอยท์ก้อนไหน)
 * และไม่รวม CIRCULAR_BIN (ยังไม่มีการแจกพอยท์จากช่องทางนี้)
 */
export const POINT_CHANNEL_SELECTABLE = [
  { value: 'HERO_ACCEPT', label: POINT_CHANNEL_LABEL.HERO_ACCEPT },
  { value: 'ANNOUNCEMENT', label: POINT_CHANNEL_LABEL.ANNOUNCEMENT },
  { value: 'LOMA', label: POINT_CHANNEL_LABEL.LOMA }
]

/**
 * ประเภทการได้พอยท์แต่ละแบบใช้มิติไม่เท่ากัน — ต้องตรงกับที่ backend เขียน scope
 * ค้นพบสินค้า/คัดแยก เกิดในแอปเสมอ ไม่มีฮีโร่ ไม่มีกิจกรรม
 */
export const GAIN_TYPE_TRANSFER = 4
export const GAIN_TYPE_WITH_HERO = [GAIN_TYPE_TRANSFER]
export const GAIN_TYPE_WITH_ACTIVITY = [GAIN_TYPE_TRANSFER]
export const GAIN_TYPE_WITH_CHANNEL = [GAIN_TYPE_TRANSFER]

/** ค่าเริ่มต้นของคูปองตาม design */
export const COUPON_DEFAULT = {
  VALID_DAYS: 30,
  OPEN_WINDOW_SEC: 1800
}

/**
 * ประเภทของรางวัลที่แสดงเป็นตัวกรองในแอป
 *
 * `value` คือข้อความที่เก็บลงคอลัมน์ catagories และแอปใช้จับคู่ตัวกรอง
 * ห้ามแก้ เพราะรางวัลที่สร้างไว้แล้วจะหลุดจากตัวกรองทันที
 * เปลี่ยนได้เฉพาะ `label` ที่เป็นคำที่คนอ่าน
 */
export const REWARD_CATAGORY = [
  { value: 'สินค้า', label: 'สินค้า' },
  { value: 'ส่วนลด', label: 'บัตรกำนัล' },
  { value: 'บริจาค', label: 'บริจาค' },
  { value: 'แลกลุ้น', label: 'แลกลุ้น' }
]

export const REDEEM_STATUS = {
  DONE: 'จัดส่งเรียบร้อย',
  WAITING: 'อยู่ในระหว่างการจัดส่ง',
  CANCEL: 'ยกเลิก'
}

export const EQUIPMENT_CATEGORY = [
  'หมวดเครื่องชั่ง',
  'หมวดเครื่องอัด',
  'หมวดเครื่องจักร',
  'หมวดรถ',
  'หมวดเครื่องมือ',
  'หมวดอุปกรณ์สิ้นเปลือง',
  'หมวดอุปกรณ์สำนักงาน',
  'หมวดอื่นๆ'
]

export const ADDRESS_TYPE = {
  PERSONAL: 'บุคคลธรรมดา',
  CORPORATE: 'นิติบุคคล'
}

export const SUBSCRIPTION_PACKAGE_STATUS = [
  'ACTIVE',
  'EXPIRED',
  'CANCELLED',
  'RENEW',
  'PENDING'
]

/**
 * คำอธิบายภาษาไทยของค่าคอนฟิกที่แอดมินต้องแตะบ่อย
 *
 * ตาราง AppConfig เก็บชื่อเป็นคีย์ภาษาอังกฤษล้วน อ่านแล้วเดาหน่วยไม่ออก
 * เช่น NEARBY_HERO_DISTANCE เป็นเมตรหรือกิโลเมตรก็ไม่มีอะไรบอก
 * ตั้งผิดหน่วยหนึ่งครั้งกระทบผู้ใช้ทั้งระบบ
 */
export const APP_CONFIG_META = {
  PO_LIMIT_COIN: {
    label: 'เพดานพอยท์ต่อวัน',
    unit: 'พอยท์',
    hint: 'พอยท์สูงสุดที่ผู้ใช้หนึ่งคนได้รับจากการส่งต่อใน 1 วัน',
    integer: true
  },
  TRANSFER_RADIUS: {
    label: 'รัศมีส่งต่อ',
    unit: 'เมตร',
    hint: 'ผู้ใช้ต้องอยู่ห่างจากฮีโร่ไม่เกินระยะนี้จึงจะกดส่งต่อได้',
    integer: true
  },
  TRANSFER_MIN_POINT: {
    label: 'พอยท์ขั้นต่ำต่อการส่งต่อ',
    unit: 'พอยท์',
    hint: 'ได้อย่างน้อยเท่านี้ต่อการส่งต่อ 1 ครั้ง · ใส่ 0 = ไม่มีขั้นต่ำ',
    integer: true,
    allowZero: true
  },
  NEARBY_HERO_DISTANCE: {
    label: 'รัศมีค้นหาฮีโร่',
    unit: 'เมตร',
    hint: 'ใช้ตอนแสดงรายชื่อฮีโร่ใกล้ตัวเท่านั้น ไม่เกี่ยวกับสิทธิ์ส่งต่อ',
    integer: true
  }
}
